<template>
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3">
                <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">Security Settings Update</h1>
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1">
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">Home</router-link>
                        </a>
                    </li>
                    <li class="breadcrumb-item text-gray-600">
                        <router-link :to="{ name: 'Settings' }" >Settings</router-link>
                    </li>
                    <li class="breadcrumb-item text-gray-600">
                        <router-link :to="{ name: 'SystemSettings' }">System Settings</router-link>
                    </li>
                    <li class="breadcrumb-item text-gray-600">
                        <router-link to="/SecuritySettings">Security Settings</router-link>
                    </li>
                    <li class="breadcrumb-item text-gray-600">Security Settings Update</li>
                </ul>
            </div>
            <div class="d-flex align-items-center py-1">
                <router-link to="/SecuritySettings">
                    <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                        <span class="ms-2 fs-7"> Return back to List </span>
                    </button>
                </router-link>
                &nbsp;
                <div class="dropdown">
                    <button class="btn btn-light-info border border-info dropdown-toggle" type="button" @click="this.isOpenActionsDropdown = !this.isOpenActionsDropdown;">
                        <span class="svg-icon svg-icon-muted">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor" />
                                <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor" />
                            </svg>
                        </span>
                        Actions
                    </button>
                    <ul class="dropdown-menu" :class="{ 'show': this.isOpenActionsDropdown }">
                        <li>
                            <a class="dropdown-item fs-4 text-danger" href="#" @click="deleteItem()">
                                <span class="svg-icon svg-icon-muted svg-icon-2 text-danger">
                                    <svg width="24" height="24" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor" />
                                        <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor" />
                                        <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor" />
                                    </svg>
                                </span>
                                Delete 
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="content flex-row-fluid mt-6" id="kt_content">
            <RequiredField></RequiredField>
            <div class="row">
                <div class="tab-content" id="myTabContent">
                    <div class="card card-xxl-stretch tab-pane fade show active" id="kt_accounting_1" role="tabpanel">
                        <div class="p-10">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="d-flex flex-row row">
                                        <div class="d-flex flex-column flex-row-auto col-lg-6">
                                            <div class="d-flex flex-column-fluid card card-xxl-stretch mb-xxl-6 bg-lighten border border-secondary">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3 required">
                                                                Setting Type
                                                            </label>
                                                            <Select2 v-model="form.rate_type" :options="this.rateTypeList" :settings="{ width: '100%' }"/>
                                                        </div>
                                                        <div class="col-lg-12" v-if="form.rate_type == 2">
                                                            <label class="fs-6 fw-bold form-label mt-3 required">
                                                                IP
                                                            </label>
                                                            <div class="input-group">
                                                                <input ref="ip1" type="number" max="255" min="0" class="form-control" v-model="form.ip1" placeholder="000">
                                                                <span class="input-group-text" >.</span>
                                                                <input ref="ip2" type="number" max="255" min="0" class="form-control" v-model="form.ip2" placeholder="000" >
                                                                <span class="input-group-text" >.</span>
                                                                <input ref="ip3" type="number" max="255" min="0" class="form-control" v-model="form.ip3" placeholder="000" >
                                                                <span class="input-group-text" >.</span>
                                                                <input ref="ip4" type="number" max="255" min="0" class="form-control" v-model="form.ip4" placeholder="000" >
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3 ">
                                                                Endpoint
                                                            </label>
                                                            <div class="input-group">
                                                                <Select2 v-model="form.endpoint_type" :options="endpointTypeList" :settings="{ width: '100%' }"/>
                                                                <input ref="rate_endpoint" type="text" class="form-control" v-model="form.rate_endpoint">
                                                            </div>
                                                            <div class="d-flex mt-2">
                                                                <i class="bi bi-info-circle text-primary fs-3 ms-3 me-3" ></i>
                                                                <small v-if="form.endpoint_type != 3">if you want to apply rate limiting for all operations. Type '/*' in the Endpoint section</small>
                                                                <small v-if="form.endpoint_type == 3">If you want to impose rate limitation for all its operations. Leave the Endpoint section blank</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column flex-row-auto col-lg-6">
                                            <div class="d-flex flex-column-fluid card card-xxl-stretch mb-xxl-6 bg-lighten border border-secondary">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <label class="fs-6 fw-bold form-label mt-3 required">
                                                                Period
                                                            </label>
                                                            <div class="input-group">
                                                                <input ref="rate_period" type="number" class="form-control" v-model="form.rate_period">
                                                                <Select2 v-model="form.period_id" :options="periodTypeList" :settings="{ width: '100%' }" />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label class="fs-6 fw-bold form-label mt-3 required">
                                                                Limit
                                                            </label>
                                                            <div class="position-relative">
                                                                <input ref="rate_limit" type="number" class="form-control" v-model="form.rate_limit">
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label class="fs-6 fw-bold form-label mt-3" for="isActive">
                                                                Active
                                                            </label>
                                                            <div class="form-check mt-3 mb-3">
                                                                <input class="form-check-input" type="checkbox" value="" id="isActive" v-model="form.isActive">
                                                            </div> 
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 mt-5">
                                    <div class="d-grid gap-2">
                                        <button type="button" class="btn btn-lg btn-primary" @click="this.saveData()" data-kt-indicator="on">
                                            <span class="svg-icon svg-icon-2">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor" />
                                                    <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor" />
                                                </svg>
                                            </span>
                                            <strong v-if="!this.isProgressing"> Save Rate Limit Role </strong>
                                            <span class="indicator-progress" v-if="this.isProgressing">
                                                Saving Data... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name:'SecuritySettingsUpdate',
    data(){
        return {
            form: {
                id: '',
                rate_type: 1,
                rate_ip: '',
                rate_endpoint: '',
                rate_period: '',
                rate_period_time: '',
                rate_limit: 1,
                period_id: 1,
                ip1: '',
                ip2: '',
                ip3: '',
                ip4: '',
                endpoint_type: 1,
                is_active: 1,
                isActive: true
            },
            isProgressing: false,
            endpointTypeList: [
                { id: 1, text: 'GET' },
                { id: 2, text: 'POST' },
                { id: 3, text: '*' }
            ],
            periodTypeList: [
                { id: 1, text: 's' },
                { id: 2, text: 'm' },
                { id: 3, text: 'h' }
            ],
            rateTypeList: [{ id: 1, text: 'General Rate Limiting' }, { id: 2, text: 'Ip Rate Limiting' }],
            isOpenActionsDropdown: false
        };
    },
    methods:{
        getData(){
            const parameters = {
                session_id: this.$getUser().session_id,
                id: this.$getSessionStorage("record_id"),
            }

            axios.post('/api/SecuritySettings/GetSecuritySettingsDetailsById', parameters, {'Content-Type': 'application/json'})
                .then((response) => {
                    if (response.data.error == null || response.data.error == 'undefined' || response.data.error == '') {
                        this.form = response.data;
                        this.form.isActive = this.form.is_active == 1 ? true : false;
                        this.form.period_id = this.form.rate_period.includes("s") ? 1 : this.form.rate_period.includes("m") ? 2 : 3;
                        this.form.rate_period = response.data.rate_period.replace(/[smh]/, "");
                        if(this.form.rate_ip.includes(".")){
                            var ipList = this.form.rate_ip.split(".");
                            this.form.ip1 = ipList[0];
                            this.form.ip2 = ipList[1];
                            this.form.ip3 = ipList[2];
                            this.form.ip4 = ipList[3];
                        }
                        this.form.endpoint_type = this.form.rate_endpoint.includes("GET") ? 1 : this.form.rate_endpoint.includes("POST") ? 2 : 3
                        this.form.rate_endpoint = this.form.rate_endpoint.split(":")[1] == undefined ? '' : this.form.rate_endpoint.split(":")[1];
                        this.rate_type = this.form.rate_type;
                    }
                })
        
        },
        saveData(){
            this.form.rate_endpoint = this.form.rate_endpoint.replaceAll(' ','') == "" ? this.endpointTypeList.find(x => x.id == this.form.endpoint_type).text : `${this.endpointTypeList.find(x => x.id == this.form.endpoint_type).text}:${this.form.rate_endpoint.replaceAll(" ","")}`;
            this.form.rate_period = `${this.form.rate_period == 0 ? 1 : this.form.rate_period}${this.periodTypeList.find(x => x.id == this.form.period_id).text}`;
            const params = this.form;
            params.session_id = this.$getUser().session_id;
            if(params.rate_type == 2) {
                params.rate_ip = (!params.ip1 ? 0 : params.ip1) + '.' + (!params.ip2 ? 0 : params.ip2) + '.' + (!params.ip3 ? 0 : params.ip3) + '.' + (!params.ip4 ? 0 : params.ip4);
            }
            params.is_active = params.isActive ? 1 : 0;            
            const that = this;
            axios.post('/api/SecuritySettings/UpdateSecuritySettingsDetails', params, {'Content-Type': 'application/json'})
            .then((response) => {
                    if (response.data.error == null || response.data.error == 'undefined' || response.data.error == '') {
                        that.$swal("Success", "Data saved succesfully..!", 'success');
                        that.$setSessionStorage('refreshList', true);
                        that.$setSessionStorage("record_id", response.data);
                        this.getData();
                    }
                })
                .catch(function (error) {
                    console.error(error);
                    that.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!");
                })
                .finally(function () {
                    that.form.rate_period = that.form.rate_period.replace(/[smh]/, "");
                    that.form.rate_endpoint = that.form.rate_endpoint.split(":")[1] == undefined ? '' : that.form.rate_endpoint.split(":")[1];
                    setTimeout(() => {
                        that.isProgressing = false;
                    }, 500);
                });
        },
        deleteItem(){
            this.$swal.fire({
            title: "Are you sure you want to remove this item?",
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "DELETE",
            icon: 'info'
        })
        .then((result) => {
                if (result.isConfirmed) { 
                    const params={
                    session_id: this.$getUser().session_id,
                    id: this.form.id,
                }
                axios.post('/api/SecuritySettings/DeleteSecuritySettingsDetails',params, {'Content-Type': 'application/json'})
                .then(() => {
                    this.$router.push({ name: 'SecuritySettings'});
                })
                }else{
                    this.isOpenActionsDropdown= false;
                }
            }); 
        }
    },
    created(){
        this.getData();
    }
}
</script>